import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OpinButtonModule } from '../../atoms/button/button.module';
import { OpinIconModule } from '../../atoms/icon/icon.module';
import { OpinLabelModule } from '../../atoms/label/label.module';

import { OpinAlertComponent } from './alert.component';

@NgModule({
  exports: [OpinAlertComponent],
  declarations: [OpinAlertComponent],
  imports: [CommonModule, OpinIconModule, OpinLabelModule, OpinButtonModule]
})
export class OpinAlertModule {}
